import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getAverageLabelPrice = {
  name: "getAverageLabelPrice" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
